import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

const TokenActions = {
    updateDevice (token) {
        AppDispatcher.dispatch({
            token: token,
            actionType: ActionTypes.DEVICE_TOKEN_UPDATED
        });
    }
};

export default TokenActions;
